import React from 'react';
import investBg from '../../../assets/site/bg-invest.jpg';
import FeatureCard from '../../site/components/FeatureCard';
import Section from '../../site/components/Section';
import SectionHead from '../../site/components/SectionHead';
import { investmentOptions } from '../../site/data/content';
import ui from '../../site/styles/primitives.module.css';

const InvestmentOptions = () => (
  <Section id="invest" background={investBg} backgroundPosition="center 55%">
    <div className={ui.wrap}>
      <SectionHead
        eyebrow="Invest with DS360"
        title="Real estate investing,"
        highlight="built around you"
        lede="Choose the way you want to participate. We handle sourcing, structuring and delivery."
      />
      <div className={ui.grid3}>
        {investmentOptions.map((option, index) => (
          <FeatureCard
            key={option.title}
            image={option.image}
            tag="Opportunity"
            title={option.title}
            text={option.text}
            href="#call"
            linkLabel="Learn more"
            surface={index % 2 === 0 ? 'glass' : 'matte'}
          />
        ))}
      </div>
    </div>
  </Section>
);

export default InvestmentOptions;
